import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getNavigationMenuQueryKey } from "./useNavigationMenu";
import { appParamCacheKey } from "../appParams/useApplicationParameters";

type FeatureActivationResponse = {
    success: boolean;
    feature_key: string;
    menus_updated: boolean;
    menus_count?: number;
};

export const useFeatureActivation = () => {
    const queryClient = useQueryClient();

    const activateFeature = useMutation({
        mutationFn: async (featureKey: string): Promise<FeatureActivationResponse> => {
            const response = await loggedInApiCall.post(`/api/application_parameters/${featureKey}/activate`);
            return response.data;
        },
        onSuccess: () => {
            // Invalidate queries - React Query will auto-refetch for active queries
            queryClient.invalidateQueries([appParamCacheKey]);
            queryClient.invalidateQueries([getNavigationMenuQueryKey]);
        },
    });

    const deactivateFeature = useMutation({
        mutationFn: async (featureKey: string): Promise<FeatureActivationResponse> => {
            const response = await loggedInApiCall.post(`/api/application_parameters/${featureKey}/deactivate`);
            return response.data;
        },
        onSuccess: () => {
            // Invalidate queries - React Query will auto-refetch for active queries
            queryClient.invalidateQueries([appParamCacheKey]);
            queryClient.invalidateQueries([getNavigationMenuQueryKey]);
        },
    });

    return {
        activateFeature,
        deactivateFeature,
        isActivating: activateFeature.isLoading,
        isDeactivating: deactivateFeature.isLoading,
    };
};
